import { SET_DETAILS, UPDATE_DETAILS } from '../actions';
import { prepareLeaderBoardDetails } from './prepareLeaderBoard';

export default (state = {}, action) => {
    switch (action.type) {
        case SET_DETAILS: {
            const { details } = action.payload;

            return {
                ...state,
                details: prepareLeaderBoardDetails(details)
            };
        }
        case UPDATE_DETAILS: {
            const { details } = action.payload;
            const { leaderboardId } = state;

            if (details.leaderboardId !== leaderboardId) {
                return state;
            }

            return {
                ...state,
                details: prepareLeaderBoardDetails({
                    ...state.details,
                    ...details
                })
            };
        }
        default:
            return state;
    }
};
